import _ from 'lodash';
import Promise from 'bluebird';
import getHelpers from '../helpers';
const api = getHelpers('api');

// initial state
const state = {
    ...window.store,
    notifications: [],
    timestamp: Date.now(),
}

// getters
const getters = {
    // customers: (state) => state.customers,
    logins: (state) => state.logins,
    suppliers: (state) => state.suppliers,
    // markets: (state) => state.markets,
    // notifications: (state) => state.notifications,
    timestamp: (state) => state.timestamp,
    route: (state) => (name, params) => {
        let path = '/' + _.get(state, ['routes', name]);

        _.forEach(params, (value, key) => {
            path = _.replace(path, new RegExp(`{${key}[?]?}`), value);
        })

        return path;
    }
}

const actions = {
    // setProduct({ commit }, res) {
    //     commit('setProduct', res);
    //     return res;
    // },
}

// mutations
const mutations = {


    addNotification(state, payload) {
        _.set(state, 'notifications', _.concat(state.notifications, [payload]));
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./resources/assets/site/js/store/main.js